export const calcCPGrate = (base_rate, tolls, bobtail) => {
   try {
      return +(base_rate ? base_rate : 0) + +(tolls ? tolls : 0) + +(bobtail ? bobtail : 0);
   } catch (err) {
      handleError(err);
   }
};
